import { WizDragDropContainer } from './drag-drop/wiz-drag-drop.directive';
import { NgModule } from '@angular/core';
import { WizNotFocusableDirective } from './wiz-not-focusable.directive';
import { WizHoldableDirective } from './wiz-holdable.directive';
import { WizTooltipDirective } from './wiz-tooltip.directive';
import { WizResizeDirective } from './wiz-resize.directive';
@NgModule({
  declarations: [
    WizNotFocusableDirective,
    WizHoldableDirective,
    WizResizeDirective,
    WizTooltipDirective,
    WizDragDropContainer,
  ],
  exports: [
    WizNotFocusableDirective,
    WizHoldableDirective,
    WizResizeDirective,
    WizTooltipDirective,
    WizDragDropContainer,
  ],
})
export class WizBehaviorDirectiveModule {}
